<template>
	<v-container fluid>
		<div v-if="!loading">
			<!--table-->
			<!--table head-->
			<v-row class="total mt-8" no-gutters>
				<v-col class="tabCell text-left">Product</v-col>
				<v-col v-for="item in headers"
					class="tabCell"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<!--table content-->
			<v-expansion-panels multiple v-model="panel">
				<v-expansion-panel
					v-for="brand in products"
					:key="brand.id"
				>
					<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
						{{ brand.trademark }}
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row v-for="model in sortedModels(brand.models)" :key="model.id" no-gutters>
							<v-col class="tabCell text-left">{{ name(model.model) }}</v-col>
							<v-col class="tabCell">{{ model.designType}}</v-col>
							<v-col class="tabCell">{{ model.designLevel}}</v-col>
							<v-col class="tabCell">{{ model.material}}</v-col>
							<v-col class="tabCell">{{ model.manufacturing}}</v-col>
							<v-col class="tabCell">{{ model.variations}}</v-col>
							<v-col class="tabCell">{{ model.advancedFeature}}</v-col>
							<v-col class="tabCell">{{ status(model.availablefrom)}}</v-col>
							<v-col class="tabCell">{{ completion(model.availablefrom, model.availabletill)}}</v-col>
							<v-col class="tabCell">{{ investments(model) }}</v-col>
							<v-col class="tabCell">{{ model.unitCost}}</v-col>
							<v-col v-if="upgradable(model, brand)" class="tabCell">
								<upgrade-model 
									:brand="brand"
									:model="model"
									:gameId="gameId"
									:round="round">
								</upgrade-model> 
								<delete-model 
									:brand="brand"
									:model="model"
									:gameId="gameId"
									:round="round"
								></delete-model>
							</v-col>
							<v-col v-else class="tabCell">
								<delete-model 
									:brand="brand"
									:model="model"
									:gameId="gameId"
									:round="round"
								></delete-model>
							</v-col>
						</v-row>
						<v-row class="mt-4" justify="end">
							<!--add new model component-->
							<add-model
								:brand="brand"
								:gameId="gameId"
								:round="round">
							</add-model>
							<!--delete brand component-->
							<delete-brand :brand="brand" :gameId="gameId" :round="round"></delete-brand>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			<v-row justify="start" class="mt-4 ml-4">
			<!--add new model component-->
				<add-brand
					:gameId="gameId"
					:round="round"
					:company="company">
				</add-brand>
			</v-row>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import addModel from '../products/addModel.vue'
	import addBrand from '../products/addBrand.vue'
	import upgradeModel from '../products/upgradeModel.vue'
	import deleteModel from '../products/deleteModel.vue'
	import deleteBrand from '../products/deleteBrand.vue'
	import Loader from '../../layouts/Loader.vue'
	import numeral from 'numeral'

	export default {
		props: ['company', 'gameId', 'round'],
		data (){
			return {
				icon: 'arrow_right',
				headers: ['Design type', 'Design level', 'Material', 'Manufacturing', 'Variations','Advanced feature', 'Status', 'Available', 'Investments', 'Unit cost', 'Action'],
				panel: [0],
				monthsName: ['Jun', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			products () {
				return this.$store.getters.products
			}
		},
		methods: {
			name (model) {
				return model.split(' - ')[1] //trademark cutted name
			},
			status (from) {
				let status = 'in progress'
				if (from == 1) {
					status = 'available'
				}
				return status
			},
			upgradable (model, brand) {
				const status = this.status(model.availablefrom)
				if (status === 'available'){
					const inBrand = brand.models.filter(mod => mod.model === model.model)
					if (inBrand.length <= 1) return true 
				}
				return false
			},
			completion (from, till) {
				if (till < 12) return `till ${this.monthsName[till-1]}`
				else if (from > 1) return `from ${this.monthsName[from-1]}`
				else  return ''
			},
			investments (model) {
				if (this.status(model.availablefrom) == 'in progress') {
					return numeral(model.investments).format('0,0[.]0')
				}
				return ' - '
			},
			sortArrObjs (arr) {
				//sort models
				arr.sort((prev, next) => {
					let p = prev.model.toLowerCase()
					let n = next.model.toLowerCase()
					if (p < n) return -1;
					if (p > n) return 1;
					return 0;
				})
				return arr
			},
			sortedModels(models) {
				//first available
				let availableArr = []
				let inProgressArr = []
				models.forEach(model => {
					if (this.status(model.availablefrom) == 'in progress') {
						inProgressArr.push(model)
					}
					else {
						availableArr.push(model)
					}
				} )
				
				availableArr = this.sortArrObjs(availableArr)
				inProgressArr = this.sortArrObjs(inProgressArr)

				return availableArr.concat(inProgressArr)
			}
		},
		components: {
			addModel,
			addBrand,
			upgradeModel,
			deleteModel,
			deleteBrand,
			Loader
		}
	}
</script>
<style>
	.tabCell{
		width: 70px;
		border-bottom: 0.5px solid grey;
		font-size: 0.9em;
	}
</style>